qw-skeleton {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
}

.grid-skeleton {
  width: 100%;
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-items: flex-start;
}

qw-skeleton.card {
  justify-content: flex-start;
  align-items: flex-start;
  box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.18);
  background-color: var(--qw-hotel-skeleton-light);
  max-width: 48%;
  display: inline-block;
  min-height: 200px;
  border-radius: 15px;
  padding: 16px 26px 16px 23px;
}

qw-skeleton.card span {
  margin-bottom: 20px;
}

qw-skeleton.card span:last-of-type {
  margin-bottom: 0;
}

qw-skeleton span:after {
  content: '';
  display: block;
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: #eee;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0) 12%,
    white 17%,
    rgba(255, 255, 255, 0) 22%
  );
  background-size: 600% 100%;
  background-position-x: 40%;
  animation: 3s shine linear infinite;
  opacity: 0.4;
}

@keyframes shine {
  to {
    background-position-x: -200%;
  }
}

qw-skeleton span {
  position: relative;
  background-color: var(--qw-hotel-skeleton-light);
  display: inline-block;
}

span[type='title'] {
  background-color: var(--qw-hotel-skeleton-dark);
  border-radius: 2px;
}
span[type='text'] {
  background-color: var(--qw-hotel-skeleton-medium);
  border-radius: 2px;
}
span[type='image'] {
  background-color: var(--qw-hotel-skeleton-medium);
}
span[type='select'] {
  border-radius: 25px;
  min-height: 24px;
  background-color: var(--qw-hotel-skeleton-medium);
}

span[type='text'] + span[type='text'] {
  margin-top: -16px; /* 4px */
}

/* SPecific for pages */

qw-extra qw-skeleton.card span[type='image'] {
  margin-right: 10%;
}

qw-extra qw-skeleton.card {
  margin-right: 2%;
  margin-bottom: 2%;
}

qw-extra qw-skeleton {
  width: 48%;
}

.basket-skeleton {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  border-radius: 5px;
}

.basket-skeleton qw-skeleton {
  padding: 4px 16px 4px;
  justify-content: space-between;
}
.basket-skeleton qw-skeleton:last-of-type {
  padding: 15px 16px 28px;
}
.basket-skeleton qw-skeleton:last-of-type span[type='select'] {
  margin: 0 auto;
}

.basket-skeleton .qw-skeleton-head {
  background-color: var(--qw-hotel-skeleton-head);
  min-height: 60px;
  padding: 15px 16px 15px;
  align-items: center;
}
.basket-skeleton .qw-skeleton-head span[type='title'] {
  background-color: var(--qw-hotel-skeleton-light);
}

.basket-skeleton qw-skeleton > span[type='text'] + span[type='text'] {
  margin-top: 0;
}

.basket-skeleton qw-skeleton:nth-of-type(5) {
  margin-top: 16px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 0;
  padding-right: 0;
  margin-left: 16px;
  margin-right: 16px;
  width: calc(100% - 32px);
  border-top: 1px solid var(--qw-hotel-skeleton-medium);
}

.basket-skeleton qw-skeleton:nth-of-type(2) {
  padding: 20px 16px 0;
}
.basket-skeleton qw-skeleton:nth-of-type(4) {
  padding: 28px 16px 20px;
}

.qw-inline-skeleton {
  display: flex;
  flex-direction: row;
  align-items: center;
  min-height: 80px;
  border-top: 1px solid var(--qw-hotel-skeleton-medium);
}

.qw-inline-skeleton .qw-skeleton-inline {
  min-width: 180px;
  border-right: 1px solid var(--qw-hotel-skeleton-medium);
  height: calc(100% - 32px);
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.qw-skeleton-inline span:first-of-type {
  margin-bottom: 4px;
}
.qw-inline-skeleton .qw-skeleton-inline:last-of-type {
  align-items: center;
}

.qw-inline-skeleton.qw-inline-skeleton--modal {
  margin-top: 20vh;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  position: relative;
  min-height: 40vh;
}
.qw-inline-skeleton.qw-inline-skeleton--modal .qw-skeleton-inline {
  margin: 0 10% 0 0;
  width: 45%;
}
.qw-inline-skeleton.qw-inline-skeleton--modal .qw-skeleton-inline:nth-child(2),
.qw-inline-skeleton.qw-inline-skeleton--modal .qw-skeleton-inline:nth-child(4) {
  margin: 0 0% 0 0;
}

.qw-inline-skeleton.qw-inline-skeleton--modal .qw-skeleton-inline:nth-child(3),
.qw-inline-skeleton.qw-inline-skeleton--modal .qw-skeleton-inline:nth-child(4) {
  margin-top: 10vh;
}

.qw-inline-skeleton.qw-inline-skeleton--modal .qw-skeleton-inline:nth-child(5) {
  position: absolute;
  right: 0;
  bottom: -10px;
  height: auto;
  border: none;
  padding: 0;
  margin: 0;
  min-width: 0;
}

qw-room-list .room-list-skeleton,
qw-basket-summary .basket-skeleton,
qw-basket-summary-mobile .basket-skeleton,
qw-book .book-skeleton {
  width: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 1;
  visibility: visible;
}

qw-basket-summary.qw-basket-summary--loading,
qw-basket-summary.loading-skeleton,
qw-basket-summary.qw-basket-summary--loading > *,
qw-basket-summary.loading-skeleton > *,
qw-basket-summary-mobile.qw-basket-summary--loading,
qw-basket-summary-mobile.loading-skeleton,
qw-basket-summary-mobile.qw-basket-summary--loading > *,
qw-basket-summary-mobile.loading-skeleton > * {
  pointer-events: none !important;
}

qw-room-list.visualize-list .room-list-skeleton,
qw-basket-summary.visualize-basket .basket-skeleton,
qw-basket-summary-mobile.visualize-basket .basket-skeleton,
qw-book.visualize-quote .book-skeleton {
  opacity: 0;
  visibility: hidden;
  transition:
    opacity 0.3s ease-in-out,
    visibility 0s ease 0.4s;

  .skeleton-card {
    display: none;
  }
}

.skeleton-card {
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  height: 350px;
  background-color: var(--qw-hotel-skeleton-light);
  margin-bottom: 30px;
  box-shadow: 0px 0px 6px rgba(0, 0, 0, 0.25);
}
.room-list-skeleton .qw-skeleton-room {
  flex-basis: 30.8%;
  width: 30.8%;
  align-items: flex-start;
  justify-content: space-between;
  padding: 20px;
}

.room-list-skeleton .qw-skeleton-room span {
  display: block;
}

.room-list-skeleton .skeleton-card .qw-skeleton-room:nth-child(2) {
  padding: 0;
  flex-basis: 30.2%;
  height: 100%;
}
.room-list-skeleton .skeleton-card .qw-skeleton-room:nth-child(3) {
  flex-basis: 39%;
}

.room-list-skeleton .qw-skeleton-room span[type='title'] {
  margin-bottom: 35px;
}

.room-list-skeleton .qw-skeleton-room span[type='title']:last-of-type {
  margin-bottom: 0px;
  align-self: flex-end;
}
.room-list-skeleton .qw-skeleton-room span[type='text'] {
  margin-bottom: 20px;
}
.room-list-skeleton .qw-skeleton-room span[type='text']:last-of-type {
  margin-bottom: 0px;
}

.room-list-skeleton .qw-skeleton-room span[type='select'] {
  margin-bottom: 18px;
}
.room-list-skeleton .qw-skeleton-room span[type='select']:last-of-type {
  margin-bottom: 0px;
}

.room-list-skeleton .qw-skeleton-room span[type='text'] + span[type='text'] {
  margin-top: 0;
}

.book-skeleton {
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.book-skeleton .qw-skeleton-title {
  height: 36px !important;
  margin-bottom: 28px;
  width: 40%;
}
.book-skeleton .qw-skeleton-title span {
  height: 36px !important;
  margin-bottom: 28px;
  width: 100% !important;
}

.book-skeleton .skeleton-card-q {
  padding: 27px 33px;
  background-color: var(--qw-hotel-skeleton-light);
  box-shadow: 0px 0px 6px rgb(0 0 0 / 25%);
  border-radius: 15px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  margin-top: 40px;
}

.book-skeleton .skeleton-card-q:first-of-type {
  margin-top: 0;
}

.qw-skeleton-quote {
  display: flex;
  flex-flow: column;
  justify-content: flex-start;
  align-items: flex-start;
  width: auto;
}
.qw-skeleton-quote:first-of-type {
  width: 20%;
}
.qw-skeleton-quote:nth-of-type(2) {
  width: 30%;
}
.qw-skeleton-quote:nth-of-type(3) {
  width: 30%;
}
.qw-skeleton-quote:nth-of-type(4) {
  width: 100%;
  margin: 32px 0;
}
.qw-skeleton-quote:nth-of-type(5) {
  width: 60%;
}
.qw-skeleton-quote:last-of-type {
  width: 30%;
}

.qw-skeleton-quote span {
  display: block;
}
.qw-skeleton-quote span[type='title'] {
  margin-bottom: 10px;
}
.qw-skeleton-quote.skeleton-title span[type='title'] {
  margin-bottom: 0px;
  width: 100% !important;
}

@media only screen and (max-width: 738px) {
  .room-list-skeleton .skeleton-card {
    height: auto;
    flex-direction: column;
  }

  .room-list-skeleton .skeleton-card .qw-skeleton-room {
    flex-basis: 100%;
    width: 100%;
  }
  .room-list-skeleton .skeleton-card .qw-skeleton-room:nth-child(3) {
    order: 2;
    flex-basis: 100%;
  }
  .room-list-skeleton .skeleton-card .qw-skeleton-room:nth-child(2) {
    order: 1;
    flex-basis: 100%;
    padding: 20px;
  }
  .room-list-skeleton .skeleton-card .qw-skeleton-room:nth-child(2) span {
    height: 250px !important;
  }
  .room-list-skeleton .skeleton-card .qw-skeleton-room:nth-child(1) {
    display: none;
  }

  .basket-summary--mobile .basket-skeleton {
    height: 100%;
    border-radius: 0;
  }

  .basket-summary--mobile .basket-skeleton .qw-skeleton-head {
    height: 80px;
    background-color: var(--qw-hotel-skeleton-light);
  }
  .basket-summary--mobile
    .basket-skeleton
    .qw-skeleton-head
    span[type='select'] {
    height: 48px;
    background-color: var(--qw-hotel-skeleton-medium);
  }
  .basket-summary--mobile
    .basket-skeleton
    .qw-skeleton-head
    span[type='title'] {
    height: 40px;
    background-color: var(--qw-hotel-skeleton-medium);
  }

  .basket-summary--mobile .basket-skeleton .qw-skeleton-basket {
    height: 54px;
    background-color: var(--qw-hotel-skeleton-medium);
    padding: 16px !important;
  }
  .basket-summary--mobile .basket-skeleton .qw-skeleton-basket span {
    width: 75% !important;
    height: 22px !important;
    background-color: var(--qw-hotel-skeleton-light);
    margin: 0 auto;
  }

  qw-basket-summary {
    pointer-events: none;
  }

  qw-basket-summary.visualize-basket {
    pointer-events: initial;
  }

  qw-basket-summary-mobile {
    pointer-events: none;
  }

  qw-basket-summary-mobile.visualize-basket {
    pointer-events: initial;
  }

  .grid-skeleton {
    flex-direction: column;
  }

  .grid-skeleton .card {
    width: calc(100% - 30px);
    flex-basis: calc(100% - 30px);
    max-width: 100%;
    margin: 0 15px 20px;
  }

  .book-skeleton .skeleton-card-q {
    padding: 20px;
    flex-direction: column;
  }
  .qw-skeleton-quote:first-of-type {
    width: 40%;
  }
  .qw-skeleton-quote:nth-of-type(2) {
    width: 100%;
  }
  .qw-skeleton-quote:nth-of-type(3) {
    width: 100%;
  }
  .qw-skeleton-quote:nth-of-type(4) {
    width: 100%;
    margin: 32px 0;
  }
  .qw-skeleton-quote:nth-of-type(5) {
    width: 100%;
  }
  .qw-skeleton-quote:last-of-type {
    width: 100%;
  }

  .book-skeleton {
    padding: 0 20px;
  }
}

@media only screen and (max-width: 1100px) {
  .grid-skeleton {
    flex-wrap: wrap;
  }
}
